import { FiSettings } from 'react-icons/fi';

const MenuItems = ({ filteredItems, addToCart, openCustomizeModal }) => {
  return (
    <div className="w-2/3 pr-6 overflow-y-auto">
      <div className="flex items-center mb-4">
        <h2 className="text-lg font-semibold text-gray-800">Menu Items ({filteredItems.length})</h2>
      </div>
      <div className="grid grid-cols-2 gap-4">
        {filteredItems.map(item => (
          <div key={item.id} className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
            <div className="flex flex-col h-full">
              <div className="flex-grow">
                <div className="flex items-center">
                  <h3 className="font-medium text-gray-800 text-lg">{item.name}</h3>
                </div>
                <p className="text-sm text-gray-500 mt-1">{item.description}</p>
              </div>
              <div className="flex justify-between items-center mt-3">
                <span className="font-medium text-gray-800 text-lg">${item.price.toFixed(2)}</span>
                <div className="flex space-x-2">
                  <button
                    onClick={() => openCustomizeModal(item)}
                    className="p-2 text-gray-500 hover:text-gray-800 hover:bg-gray-100 rounded-full transition"
                    aria-label="Customize"
                  >
                    <FiSettings size={16} />
                  </button>
                  <button
                    onClick={() => addToCart(item)}
                    className="px-4 py-2 bg-gray-800 text-white text-sm rounded-lg hover:bg-gray-700 transition"
                  >
                    + Add
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MenuItems;